/**
 * Labels for Enin constant keys (company roles), as the advisor reads them in
 * the Enin lookup widget and in the PDF Enin block.
 */

import { pickT } from "../i18n";
import type { TranslationTable } from "../types/translation-table";

type EninRoleKey =
  | "ceo"
  | "board_chairman"
  | "deputy_board_chairman"
  | "board_member"
  | "deputy_board_member"
  | "contact_person"
  | "owner";

const ENIN_ROLE_LABELS: TranslationTable<Record<EninRoleKey, string>> = {
  en_GB: {
    ceo: "CEO",
    board_chairman: "Board chair",
    deputy_board_chairman: "Deputy board chair",
    board_member: "Board member",
    deputy_board_member: "Deputy board member",
    contact_person: "Contact person",
    owner: "Owner",
  },
  nb_NO: {
    ceo: "Daglig leder",
    board_chairman: "Styreleder",
    deputy_board_chairman: "Nestleder",
    board_member: "Styremedlem",
    deputy_board_member: "Varamedlem",
    contact_person: "Kontaktperson",
    owner: "Innehaver",
  },
};

/**
 * Human label for an Enin constant key ("board_member", "ceo",
 * "board_chairman_previous_bankruptcy", …): known role keys get a localized
 * label; everything else is prettified (underscores → spaces, sentence case).
 */
export function formatEninKey(key: string | null | undefined, lang: string): string {
  if (!key) return "";
  const labels: Partial<Record<string, string>> = pickT(ENIN_ROLE_LABELS, lang);
  const known = labels[key.toLowerCase()];
  if (known) return known;
  const pretty = key.replace(/_/g, " ").trim();
  return pretty.charAt(0).toUpperCase() + pretty.slice(1);
}
